module.exports = __webpack_public_path__ + "img/horizontal_7_3_2.c3fc6661.png";